import { render, staticRenderFns } from "./CreateNewUserModal.vue?vue&type=template&id=b9d37348&"
import script from "./CreateNewUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewUserModal.vue?vue&type=style&index=0&id=b9d37348&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports